exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\ndiv[data-v-7a8231f8] {\n  color: var(--purple);\n  font-size: 14px;\n  margin: 10px 5px 0;\n  font-weight: 400;\n}\n", "", {"version":3,"sources":["/opt/build/repo/src/components/SignUp/Steps/src/components/SignUp/Steps/StepText.vue"],"names":[],"mappings":";AAWA;EACA,qBAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;CACA","file":"StepText.vue","sourcesContent":["<script>\nexport default {};\n</script>\n\n<template>\n  <div>\n    <slot />\n  </div>\n</template>\n\n<style scoped>\ndiv {\n  color: var(--purple);\n  font-size: 14px;\n  margin: 10px 5px 0;\n  font-weight: 400;\n}\n</style>\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7a8231f8","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/SignUp/Steps/StepText.vue
// module id = ZE98
// module chunks = 1